// extracted by mini-css-extract-plugin
export default {"container":"app_container__Tkwgx"};